module.exports = __webpack_public_path__ + "static/img/header_logo.8471b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header_logo.png
// module id = DAVF
// module chunks = 1